/**
 * App config API service.
 * Fetches deployment-level country/client from GET /v1/public/country-by-origin.
 * Backend resolves from request Origin header.
 */

import apiService from '@/services/api';

export interface CountryByOriginResponse {
  country: {
    id: number;
    name: string;
  };
  client: {
    id: number;
    name: string | null;
  };
  phoneConfig: {
    /** ISO 3166-1 alpha-2 code for the default phone country (e.g. 'SN'). */
    defaultCountry: string | null;
    /** ISO 3166-1 alpha-2 codes for allowed phone countries (e.g. ['SN', 'GM']). */
    allowedCountries: string[] | null;
  };
}

export const getCountryByOrigin = async (): Promise<CountryByOriginResponse> => {
  const response = await apiService.get<CountryByOriginResponse>(
    '/public/country-by-origin'
  );
  return response.data;
};
